"use strict";
class Common {
    constructor() {
        this.toTopButton = document.getElementById("to-top");
        this.init();
    }
    init() {
        window.addEventListener("scroll", this.handleScroll.bind(this));
        if (this.toTopButton) {
            this.toTopButton.addEventListener("click", this.scrollToTop.bind(this));
        }
        const anchors = document.querySelectorAll('a[href^="#"]');
        anchors.forEach((anchor) => {
            anchor.addEventListener("click", this.smoothScroll.bind(this));
        });
    }
    handleScroll() {
        if (this.toTopButton === null)
            return;
        if (window.scrollY > 100) {
            this.toTopButton.style.display = "block";
        }
        else {
            this.toTopButton.style.display = "none";
        }
    }
    scrollToTop(e) {
        e.preventDefault();
        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });
    }
    smoothScroll(e) {
        e.preventDefault();
        const anchor = e.currentTarget;
        const href = anchor.getAttribute("href");
        if (!href || href === "#")
            return;
        const target = document.querySelector(href);
        if (!target)
            return;
        const offset = window.innerWidth >= 768 ? 150 : 100 * (window.innerWidth / 375);
        const targetPosition = target.getBoundingClientRect().top + window.scrollY - offset;
        window.scrollTo({
            top: targetPosition,
            behavior: "smooth",
        });
    }
}
new Common();
